import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store'
import router from '../router'

Vue.use(VueAxios, axios)

axios.defaults.baseURL = process.env.VUE_APP_API
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
let redirect_to_login = [
  '/member/online/buy',
  '/member/cart'
]


axios.interceptors.request.use(request => {
  if(request.url.startsWith('/admin')) {
    request.headers.Authorization = store.state.admin.token
  }
  else if(request.url.startsWith('/portal')) {
    request.headers.Authorization = store.state.seller.token
  }
  else {
    // 使用會員或賣家的 token
    request.headers.Authorization = store.state.user.token || store.state.seller.token
  }
  return request
})

const errorComposer = (error) => {
  if (error.response.status == 401) {
    if(error.response.config.url.startsWith('/admin')) {
      store.dispatch('admin/logout')
      if(router.currentRoute.path != '/admin') {
        router.push('/admin')
      }
    }
    else if(error.response.config.url.startsWith('/portal')) {
      store.dispatch('seller/logout')
      if(router.currentRoute.path != '/login') {
        router.push('/login?type=seller')
      }
    }
    else {
      store.dispatch('user/logout')
      if(redirect_to_login.includes(error.response.config.url)) {
        router.push('/login')
      }
    }
  }
  else if(error.response.status == 403) {
    if(error.response.data.message.includes('The tel is not verified')) {
      vm.$root.$emit('errorDialog', ['手機尚未驗證，請先到', {link: "/profile", text: '個人頁面'}, '進行驗證。'])
    }
    else if(error.response.data.message.includes('The email is not verified')) {
      vm.$root.$emit('errorDialog', ['Email尚未驗證，請先到', {link: "/profile", text: '個人頁面'}, '進行驗證。'])
    }
    else if(error.response.data.message.includes('The email and tel are both not verified')) {
      vm.$root.$emit('errorDialog', ['Email和手機尚未驗證，請先到', {link: "/profile", text: '個人頁面'}, '進行驗證。'])
    }
    else if(error.response.data.message.includes('The identity is not verified')) {
      vm.$root.$emit('errorDialog', ['身分尚未驗證，請先', {action: () => vm.$root.$emit('authentication'), text: '進行驗證'}])
    }
  }
}

axios.interceptors.response.use(undefined, error => {
  errorComposer(error)
  return Promise.reject(error)
})

export default axios